<script>
    import {BDropdown} from 'bootstrap-vue'

    export default BDropdown.extend({
        methods: {
            focusInHandler: function focusInHandler() {
                // this.hideHandler(evt);
                // do nothing
            }
        }
    })
</script>
